import { Component } from '@angular/core';
import { ROUTER_TREE } from '../../constants/routes.constant';

@Component({
  selector: 'tad-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  public links = [
    {
      path: ROUTER_TREE.DATA_SOURCES,
      label: 'Data Sources'
    },
    {
      path: ROUTER_TREE.PRIVACY_POLICY,
      label: 'Privacy Policy'
    }
  ];
}
